import * as ko from 'knockout';
import { CfbPlayoffsVM } from './playoffs-vm';

document.addEventListener('DOMContentLoaded', () => {
  // Teams are embedded in the page via data-teams on #app-config
  const appConfigEl = document.getElementById('app-config');
  const teamsJson = appConfigEl?.dataset.teams ?? '[]';
  const teams = JSON.parse(teamsJson);

  const vm = new CfbPlayoffsVM(teams);
  (window as any).vm = vm;
  ko.applyBindings(vm, document.getElementById('content') ?? document.body);
});
